import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

const ABOUT_IMG = "https://static.prod-images.emergentagent.com/jobs/3bee16da-1518-4ecf-84ec-23daebfe4616/images/82205f4f608c454c8b65cadf9c35d24c5fb6c56b68d24ebae7211e4e3ddb72e0.png";

const WHY_POINTS = [
  "Deep expertise across compliance, cloud, and AI security domains",
  "Flexible, fractional engagement — scale up or down as you grow",
  "Startup-to-enterprise experience across SaaS, fintech, and healthtech",
  "Hands-on support, not just advisory — we build alongside your team",
  "Proven frameworks that accelerate audit readiness and customer trust",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#0A0A0B] relative grain-overlay"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text Column */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#E5A97A]/80 block mb-4">
              Why CyberTech Prefects
            </span>
            <h2 className="text-3xl sm:text-4xl tracking-tight font-medium text-white mb-6">
              Your Security Partner,{" "}
              <span className="text-[#B87333]">Not Just a Vendor</span>
            </h2>
            <p className="text-base text-zinc-400 leading-relaxed mb-8">
              We embed within your team to build security programs that scale
              with your business. From day-one compliance to advanced AI
              threat modelling, we bring the depth of a full security
              department — at a fraction of the cost.
            </p>

            <ul className="space-y-4">
              {WHY_POINTS.map((point, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 * i, duration: 0.4 }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle className="w-5 h-5 text-[#B87333] mt-0.5 shrink-0" />
                  <span className="text-sm text-zinc-300">{point}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Image Column */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="flex justify-center"
          >
            <div className="relative rounded-2xl border border-[#B87333]/20 p-2 copper-glow">
              <img
                src={ABOUT_IMG}
                alt="CyberTech Prefects - Security Excellence"
                className="rounded-xl w-full max-w-md object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
